module.exports = __webpack_public_path__ + "static/media/GettyImages-1061685670_crop.d7778fb0.jpg";